import { Link, SectionMessage, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useLocalStorage } from 'react-use'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { LocalStorageKeys } from '../../../../enums/localStorageKeys'
import { useEInvoicingSetup } from '../../hooks/useEInvoicingSetup'
import { getEInvoicingBaseUrl } from '../../utils'
import * as Styled from './styles'

interface EInvoicingDeactivedBannerProps {
  isCloseable?: boolean
  includePadding?: boolean
}

export const EInvoicingDeactivatedBanner = ({
  isCloseable = false,
  includePadding = false,
}: EInvoicingDeactivedBannerProps): ReactElement | null => {
  const { t } = useTranslation()
  const [isBannerClosed, setIsBannerClosed] = useLocalStorage<boolean>(
    LocalStorageKeys.DashboardEInvoicingDisabledBanner,
    false,
  )

  const { organization } = useUserOrganization()
  const { eInvoiceIntegration, kycUnderReview } = useEInvoicingSetup()

  const shouldHideBanner = isBannerClosed && isCloseable
  const isIntegrationDeactivated = eInvoiceIntegration?.status === 'INACTIVE' && !kycUnderReview

  const closeBanner = useCallback(() => {
    setIsBannerClosed(true)
  }, [setIsBannerClosed])

  if (!isIntegrationDeactivated || shouldHideBanner) {
    return null
  }

  return (
    <Styled.SectionWrapper includeBottomPadding={includePadding}>
      <SectionMessage
        closable={isCloseable}
        onClose={closeBanner}
        variant="error"
        title={t('dashboard.banner.e_invoicing.deactivated.title')}
      >
        <Text>
          <Trans i18nKey="dashboard.banner.e_invoicing.deactivated.subtitle">
            The e-invoices displayed below have been received prior to the deactivation. To re-activate e-invoices
            reception on your account
            <Link to={getEInvoicingBaseUrl(organization)} underlined>
              click here →
            </Link>
          </Trans>
        </Text>
      </SectionMessage>
    </Styled.SectionWrapper>
  )
}
